import type { Dict } from './uk';

/** Russian. TODO: review by a native speaker before launch. */
export const ru: Dict = {
  'app.skip': 'Перейти к содержимому',
  'app.loading': 'Загрузка…',
  'nav.cases': 'Мои дела',
  'nav.privacy': 'Мои данные',
  'nav.main': 'Основная навигация',
  'lang.label': 'Язык',
  'theme.label': 'Оформление',
  'theme.system': 'Как в системе',
  'theme.light': 'Светлая',
  'theme.dark': 'Тёмная',

  'common.retry': 'Попробовать ещё раз',
  'common.back': 'Назад',
  'common.cabinet': 'Личный кабинет',

  'login.title': 'Вход в кабинет',
  'login.intro': 'Здесь видно, как продвигается ваше дело. Здесь же можно передать нам документы и написать менеджеру. Пароль не нужен — мы отправим одноразовый код.',
  'login.method': 'Как отправить код',
  'login.byPhone': 'SMS на телефон',
  'login.byEmail': 'Письмо на email',
  'login.phoneLabel': 'Номер телефона',
  'login.emailLabel': 'Электронная почта',
  'login.destHint': 'Тот, который вы сообщили нашему менеджеру.',
  'login.phonePlaceholder': '+380 67 123 45 67',
  'login.emailPlaceholder': 'name@example.com',
  'login.submit': 'Получить код',
  'login.sending': 'Отправляем…',
  'login.codeTitle': 'Введите код',
  'login.codeSentPhone': 'Мы отправили SMS на {dest}.',
  'login.codeSentEmail': 'Мы отправили письмо на {dest}.',
  'login.codeNote': 'Если эти контакты есть у нас, код придёт в течение минуты. Он действует 10 минут.',
  'login.codeLabel': 'Код из 6 цифр',
  'login.verify': 'Войти',
  'login.verifying': 'Проверяем…',
  'login.resend': 'Отправить код ещё раз',
  'login.resendIn': 'Отправить ещё раз можно через {time}',
  'login.resent': 'Новый код отправлен.',
  'login.change': 'Изменить номер или email',
  'login.help': 'Код не приходит? Позвоните нам — поможем.',
  'login.empty': 'Введите, пожалуйста, номер телефона или email.',

  'err.invalid_destination': 'Похоже, в номере или адресе ошибка. Проверьте, пожалуйста.',
  'err.invalid_code': 'Код не подошёл или уже недействителен. Проверьте цифры или запросите новый код.',
  'err.rate_limited': 'Слишком много попыток. Подождите, пожалуйста, несколько минут и попробуйте снова.',
  'err.rate_limited_wait': 'Слишком много попыток. Попробовать снова можно через {time}.',
  'err.network': 'Нет соединения. Проверьте интернет и попробуйте ещё раз.',
  'err.unauthorized': 'Сеанс завершился. Войдите, пожалуйста, снова.',
  'err.forbidden': 'Нет доступа к этой странице.',
  'err.not_found': 'Не удалось найти эту страницу или документ.',
  'err.validation': 'Проверьте, пожалуйста, введённые данные.',
  'err.generic': 'Что-то пошло не так. Попробуйте ещё раз или напишите нам в чат.',
  'err.code_incomplete': 'Введите все 6 цифр кода.',

  'cases.title': 'Мои дела',
  'cases.empty': 'Пока здесь нет дел. Если вы только что обратились к нам, дело появится после разговора с менеджером.',
  'cases.number': 'Дело № {n}',
  'cases.updated': 'Обновлено {date}',
  'cases.now': 'Сейчас',
  'cases.open': 'Открыть дело',

  'case.sections': 'Разделы страницы',
  'case.stages': 'Этапы',
  'case.stage.done': 'Выполнено',
  'case.stage.current': 'Сейчас',
  'case.stage.next': 'Далее',
  'case.needs': 'Что нужно от вас',
  'case.needsIntro': 'Сфотографируйте документ телефоном или выберите файл. Главное, чтобы текст был хорошо виден.',
  'case.needsDone': 'Спасибо. Сейчас от вас ничего не нужно.',
  'case.needsCount': 'Осталось: {n}',
  'case.rejectedReason': 'Что не так: {reason}',
  'case.rejectedNoReason': 'Менеджер объяснит в чате, что нужно исправить.',
  'case.replaceHint': 'Ошиблись с файлом? Можно отправить другой, пока мы его не проверили.',

  'status.missing': 'Нужно',
  'status.optional': 'По желанию',
  'status.uploaded': 'На проверке',
  'status.accepted': 'Принято',
  'status.rejected': 'Нужно переделать',

  'upload.takePhoto': 'Сфотографировать',
  'upload.chooseFile': 'Выбрать файл',
  'upload.replace': 'Отправить другой файл',
  'upload.limits': 'Фото или PDF, до {mb} МБ.',
  'upload.preparing': 'Готовим…',
  'upload.uploading': 'Загрузка: {pct}%',
  'upload.finishing': 'Сохраняем…',
  'upload.done': 'Файл получен. Мы проверим его в ближайшее время.',
  'upload.tooLarge': 'Файл слишком большой ({size}). Максимум — {mb} МБ. Попробуйте сфотографировать ещё раз или уменьшить PDF.',
  'upload.badType': 'Этот тип файла не подходит. Подойдут фото (JPG, PNG, HEIC) или PDF.',
  'upload.empty': 'Файл пустой. Попробуйте выбрать его ещё раз.',
  'upload.failed': 'Не удалось загрузить файл.',
  'upload.retry': 'Попробовать ещё раз',
  'upload.cancel': 'Отменить',
  'upload.progress': 'Ход загрузки',

  'docs.fromUs': 'Документы от нас',
  'docs.empty': 'Когда мы подготовим документы, они появятся здесь.',
  'docs.download': 'Скачать',
  'docs.opening': 'Открываем…',
  'docs.yours': 'Отправленные вами',

  'chat.title': 'Чат с менеджером',
  'chat.intro': 'Пишите, когда вам удобно. Менеджер ответит как можно скорее.',
  'chat.urgentCall': 'В срочных вопросах лучше позвонить:',
  'chat.empty': 'Сообщений пока нет. Можете задать любой вопрос.',
  'chat.label': 'Ваше сообщение',
  'chat.placeholder': 'Напишите сообщение…',
  'chat.send': 'Отправить',
  'chat.sending': 'Отправляется…',
  'chat.failed': 'Не отправлено.',
  'chat.retry': 'Отправить ещё раз',
  'chat.you': 'Вы',
  'chat.manager': 'Менеджер',
  'chat.offline': 'Нет соединения. Новые сообщения появятся, как только связь восстановится.',

  'timeline.title': 'История',
  'timeline.empty': 'Пока событий нет.',
  'event.case_created': 'Дело открыто',
  'event.state_changed': 'Новый этап: {state}',
  'event.state_changed_plain': 'Дело перешло на новый этап',
  'event.document_uploaded': 'Документ получен: {doc}',
  'event.document_accepted': 'Документ принят: {doc}',
  'event.documents_accepted': 'Документы приняты: {docs}',
  'event.documents_uploaded': 'Документы получены: {docs}',
  'event.document_rejected': 'Документ нужно переделать: {doc}',
  'event.document_ready': 'Документ подготовлен: {doc}',
  'event.document_plain': 'Обновление по документам',
  'event.message': 'Новое сообщение от менеджера',
  'event.generic': 'Обновление по делу',
  'event.order_shipped': 'Заказ отправлен',
  'event.order_completed': 'Заказ выполнен',

  'privacy.title': 'Мои данные',
  'privacy.intro': 'Мы храним только то, что нужно для вашего дела, и никому не передаём без необходимости.',
  'privacy.exportTitle': 'Копия ваших данных',
  'privacy.exportHint': 'Файл со всем, что мы о вас храним (по правилам GDPR).',
  'privacy.export': 'Скачать мои данные',
  'privacy.exporting': 'Готовим файл…',
  'privacy.exported': 'Файл сохранён на ваше устройство.',
  'privacy.erase': 'Если хотите, чтобы мы удалили ваши данные, напишите нам. Мы ответим в течение 30 дней.',
  'privacy.contacts': 'Контакты',
  'privacy.phone': 'Телефон',
  'privacy.duty': 'Круглосуточно',
  'privacy.email': 'Email',
  'privacy.dpo': 'Вопросы о данных',
  'privacy.company': 'Компания',
  'privacy.address': 'Адрес',
  'privacy.session': 'Выход',
  'privacy.logoutHint': 'Если вы пользуетесь чужим телефоном или компьютером, выйдите после работы.',
  'privacy.logout': 'Выйти из кабинета',
  'privacy.loggingOut': 'Выходим…',

  // --- phase 5: steps, notifications, feedback, case site
  'nav.notifications': 'Уведомления',
  'notif.title': 'Уведомления',
  'notif.intro': 'Здесь хранятся все сообщения по вашим делам, даже если письмо или SMS не дошли.',
  'notif.empty': 'Пока уведомлений нет.',
  'notif.via.email': 'Отправлено на e-mail',
  'notif.via.sms': 'Отправлено в SMS',
  'notif.via.telegram': 'Отправлено в Telegram',
  'notif.via.viber': 'Отправлено в Viber',
  'notif.via.whatsapp': 'Отправлено в WhatsApp',
  'notif.logged': 'Сохранено в кабинете',
  'notif.queued': 'Отправим утром',
  'notif.new': 'Новое',
  'notif.unread': 'Новых уведомлений: {n}',
  'notif.more': 'Показать предыдущие',
  'notif.today': 'Сегодня',
  'notif.yesterday': 'Вчера',
  'step.accepted': 'Приняли дело',
  'step.docs_collecting': 'Собираем документы',
  'step.docs_ready': 'Документы готовы',
  'step.picked_up': 'Тело забрали',
  'step.in_transit': 'В пути',
  'step.border_crossed': 'Пересекли границу',
  'step.delivered': 'Доставили',
  'step.burial': 'Погребение',
  'step.hint.accepted': 'Мы приняли дело и уже работаем над ним.',
  'step.hint.docs_collecting': 'Собираем нужные документы. Если что-то понадобится от вас, мы напишем.',
  'step.hint.docs_ready': 'Документы готовы. Готовим следующий шаг.',
  'step.hint.picked_up': 'Мы позаботимся обо всём необходимом.',
  'step.hint.in_transit': 'Мы сообщим, когда будет пересечена граница и когда прибудем.',
  'step.hint.in_transit_local': 'Мы сообщим, когда прибудем.',
  'step.hint.border_crossed': 'Граница позади. Мы сообщим, когда прибудем.',
  'step.hint.delivered': 'Мы на месте. Менеджер свяжется с вами насчёт следующих шагов.',
  'step.hint.burial': 'Мы рядом, если понадобится помощь. Напишите менеджеру в чате.',
  'event.step': 'Новый шаг: {step}',
  'feedback.title': 'Как мы справились?',
  'feedback.intro': 'Несколько слов от вас помогут нам быть внимательнее к другим семьям.',
  'feedback.rating': 'Оценка от 1 до 5',
  'feedback.rate': '{n} из 5',
  'feedback.scale': '1 — плохо, 5 — очень хорошо',
  'feedback.text': 'Что мы могли бы сделать лучше? (необязательно)',
  'feedback.optOut': 'Больше не присылать мне такие запросы',
  'feedback.submit': 'Отправить ответ',
  'feedback.sending': 'Отправляем…',
  'feedback.pickRating': 'Пожалуйста, выберите оценку.',
  'feedback.thanks': 'Спасибо. Ваш ответ важен для нас.',
  'feedback.expired': 'Срок для ответа истёк. Вы всегда можете написать менеджеру в кабинете.',
  'feedback.optedOut': 'Вы отказались от таких запросов, поэтому мы больше не будем их присылать.',
  'feedback.optedOutDone': 'Больше не будем присылать вам такие запросы.',
  'feedback.notFound': 'Ссылка недействительна. Если хотите поделиться впечатлениями, напишите менеджеру в кабинете.',
  'feedback.card': 'Отзыв',
  'feedback.cardIntro': 'Если у вас есть минута, расскажите, как мы справились.',
  'feedback.toCabinet': 'Перейти в кабинет',
  'privacy.feedbackTitle': 'Запросы отзыва',
  'privacy.feedbackHint': 'После завершения дела мы можем один раз спросить, как мы справились.',
  'privacy.feedbackOptOut': 'Не присылать мне запросы отзыва',
  'privacy.saved': 'Сохранено.',
  'site.contacts': 'Связаться с нами',
};
